/**
 * Insurance Requests Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageInsuranceRequestsComponent,
  AsyncAddInsuranceRequestComponent,
  AsyncGetReceivedInsuranceRequestsComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageInsuranceRequestsComponent}
      />
      <Route
        path={`${match.url}/create`}
        component={AsyncAddInsuranceRequestComponent}
      />
      <Route
        path={`${match.url}/view-received`}
        component={AsyncGetReceivedInsuranceRequestsComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
